import { cloneDeep, get, lowerCase, map, set, split } from "lodash";
import { MenuItem } from "@bizform/primereact/components/menuitem/MenuItem";
import { StringHelper } from "@bizform/helper/dist/js/bizflow/helper.min";
import { JSMap } from "@bizform/type/model/component_element/ComponentElement.model";
import { ITEMKEY } from "../BfAccordionMenu";

// TODO:
//  source 리팩토링 할 것!!!, helper 클래스라지만
//  연관성이 별로 없는 용도로 활용하기 위해서 클래스 변수들과 메소드들이 사용되고 있다.
export class MenuControlHelper {
    private _searchLowerText: string;
    private _accStrMap: JSMap<string>;
    private _filteredMenuItems: MenuItem[];
    private _parentMenuItems: MenuItem[];

    constructor(private _models: Array<MenuItem>) {
        this._init(null);
    }

    private _init(_searchText: string) {
        this._searchLowerText = lowerCase(_searchText);
        this._accStrMap = {};
        this._filteredMenuItems = [];
        this._parentMenuItems = [];
    }

    /**
     * MenuItem 모델에서 leaf 노드가 아닌 모든 노드를 추출한다.
     * @param models
     */
    getAllParentNodes(): MenuItem[] {
        this._init("");
        this._traverse4GettingParentNodes(this._models);
        return this._parentMenuItems;
    }

    /**
     * MenuItem 모델의 각각의 Item 객체에 unique key를 부여한다.
     */
    markItemKey(): void {
        this._traverse4MarkItemKey(this._models);
    }

    /**
     * search input에 입력된 내용에 match되는 메뉴 아이템들을 얻는다.
     */
    getFilteredMenuItem(searchText: string): MenuItem[] {
        this._init(searchText);

        this._traverse4Filter(this._models, "", false);
        const _this = this;
        map(this._accStrMap, function (value, key) {
            _this._setFilteredMenuItem(key);
        });
        this._traverse4RemovingUndefinedItem(this._filteredMenuItems);
        // console.log(this._accStrMap);
        return this._filteredMenuItems;
    }

    private _setFilteredMenuItem(path): void {
        const tmpObj = cloneDeep(get(this._models, path));
        if (tmpObj.hasOwnProperty("items") && this._isArray(tmpObj.items)) {
            tmpObj.items.length = 0;
        }
        set(this._filteredMenuItems, path, tmpObj);
    }

    private _traverse4Filter(x: any, accStr: string, isLeaf: boolean, key?: string): void {
        if (this._isArray(x)) {
            this._traverseArray4Filter(x, accStr, false);
        } else if (typeof x === "object" && x !== null) {
            const isLeaf = !x.hasOwnProperty("items") || !this._isArray(x) || (this._isArray(x) && x.items.length === 0);
            this._traverseObject4Filter(x, accStr, isLeaf);
        } else {
            /* leaf 노드의 label만 비교한다. */
            if (isLeaf && key && key === "label" && x) {
                const value = lowerCase(x);
                if (value.indexOf(this._searchLowerText) !== -1) {
                    const tmpArr = split(accStr, ".");
                    let tmpAccStr = "";
                    for (let idx = 0; idx < tmpArr.length - 1; ++idx) {
                        tmpAccStr += idx === 0 ? tmpArr[idx] : "." + tmpArr[idx];
                        this._accStrMap[tmpAccStr] = "";
                    }
                }
            }
        }
    }

    private _traverseArray4Filter(arr: Array<any>, accStr: string, isLeaf: boolean) {
        const _this = this;
        arr.forEach(function (x, index) {
            _this._traverse4Filter(x, accStr + "[" + index + "]", isLeaf);
        });
    }

    private _traverseObject4Filter(obj: any, accStr: string, isLeaf: boolean) {
        const _this = this;
        for (let key in obj) {
            if (obj.hasOwnProperty(key)) {
                _this._traverse4Filter(obj[key], accStr + "." + key, isLeaf, key);
            }
        }
    }

    private _isArray(o: any) {
        return Object.prototype.toString.call(o) === "[object Array]";
    }

    /**
     * filtering후 lodash set 메소드 호출로 filteredItem을 생성할 때
     * 생기는 undefiend item(empty item)을 배열에서 제거하기 위해서
     * 다시 filteredItem을 순회하면서 undefiend item을 제거한다.
     * @param x
     * @private
     */
    private _traverse4RemovingUndefinedItem(x: any): void {
        if (this._isArray(x)) {
            for (let i = x.length - 1; i >= 0; --i) {
                if (x[i] === null || x[i] === undefined) {
                    x.splice(i, 1);
                }
            }
            // this._traverseArray4RemovingUndefinedItem(x);
            this._traverseArray(x, this._traverse4RemovingUndefinedItem);
        } else if (typeof x === "object" && x !== null) {
            // this._traverseObject4RemovingUndefinedItem(x);
            this._traverseObject(x, this._traverse4RemovingUndefinedItem);
        }
    }

    private _traverse4GettingParentNodes(x: any): void {
        if (this._isArray(x)) {
            this._traverseArray(x, this._traverse4GettingParentNodes);
        } else if (typeof x === "object" && x !== null) {
            const isLeaf = !x.hasOwnProperty("items") || (this._isArray(x) && x.items.length === 0);
            if (!isLeaf) {
                this._parentMenuItems.push(x);
            }
            this._traverseObject(x, this._traverse4GettingParentNodes);
        }
    }

    private _traverse4MarkItemKey(x: any): void {
        if (this._isArray(x)) {
            this._traverseArray(x, this._traverse4MarkItemKey);
        } else if (typeof x === "object" && x !== null) {
            if (!x.hasOwnProperty(ITEMKEY)) {
                // ITEMKEY 프로퍼티를 가지고 있지 않다면 생성해준다.
                x[ITEMKEY] = StringHelper.randomString();
            }

            this._traverseObject(x, this._traverse4MarkItemKey);
        }
    }

    private _traverseArray(arr: Array<any>, callbackTraverse: Function) {
        // const _this = this;
        callbackTraverse = callbackTraverse.bind(this);
        arr.forEach(function (x, index) {
            // _this._traverse4RemovingUndefinedItem(x);
            callbackTraverse(x);
        });
    }

    private _traverseObject(obj: any, callbackTraverse: Function) {
        // const _this = this;
        callbackTraverse = callbackTraverse.bind(this);
        for (let key in obj) {
            if (obj.hasOwnProperty(key)) {
                // _this._traverse4RemovingUndefinedItem(obj[key]);
                callbackTraverse(obj[key]);
            }
        }
    }
}